<template lang="pug">
div(v-if='staticTotalBrands >= minBrands' class='flex justify-around items-center overflow-hidden')
  div(
    v-for='(letter, index) in letters'
    :key='index'
    class='uppercase text-center py-5 px-3 text-lg font-bold'
    :class='classObject(letter)'
    @click='filter(letter)'
  ) {{ letter.text }}
</template>

<script>
export default defineNuxtComponent({
  name: 'BrandsLetterList',
  data() {
    return {
      staticTotalBrands: 0,
      minBrands: 30,
      letters: [],
    }
  },
  created() {
    this.staticTotalBrands = this.$algolia.searchContexts.brands.state.value.resultCount

    this.letters = letterGroups().map((letter) => {
      const group = {
        text: letter,
        enabled: false,
        selected: false,
      }

      if (this.$algolia.searchContexts.brands.state.value.refinements.group) {
        group.enabled = this.$algolia.searchContexts.brands.state.value.refinements.group.some(
          ({ value }) => letter === value
        )
      }

      return group
    })
  },
  methods: {
    filter(letter) {
      if (!letter.enabled) return

      this.$algolia.searchContexts.brands.clearRefinements().setQuery()
      this.letters.forEach((l) => {
        // if the letter is already selected then we want to unselect it,
        // otherwise we just need to check if the current letter is the same as the letter we passed to the function.
        l.selected = l.selected ? false : l.text === letter.text
      })

      if (letter.selected) this.$algolia.searchContexts.brands.addRefinements('group', letter.text)

      // emit up so it triggers a search
      this.$emit('search')
    },
    classObject(letter) {
      return {
        'text-white bg-gray-darker cursor-pointer': letter.selected,
        'text-gray-light cursor-default hover:bg-transparent focus:bg-transparent': !letter.enabled,
        'text-gray-dark hover:text-gray-darker focus:text-gray-darker cursor-pointer':
          !letter.selected && letter.enabled,
      }
    },
  },
})
</script>
